// extracted by mini-css-extract-plugin
export var MoreProjects = "style-module--MoreProjects--06375";
export var Projects = "style-module--Projects--a4194";